export const focusableElements =
  'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

function focustrapEvent(event: KeyboardEvent, el: HTMLElement | undefined) {
  const firstFocusableElement = el?.querySelectorAll(
    focusableElements,
  )[0] as HTMLElement;
  const focusableContent = el?.querySelectorAll(focusableElements) ?? [];
  const lastFocusableElement = focusableContent[
    focusableContent.length - 1
  ] as HTMLElement;
  const isTabPressed = event.key === 'Tab';
  if (!isTabPressed) {
    return;
  }

  if (event.shiftKey) {
    // if shift key pressed for shift + tab combination
    if (document.activeElement === firstFocusableElement) {
      lastFocusableElement.focus();
      event.preventDefault();
    }
    // if tab key is pressed
  } else if (document.activeElement === lastFocusableElement) {
    firstFocusableElement?.focus();
    event.preventDefault();
  }
}

/**
 * @param el
 */
export function addTrapFocusToElement(el: HTMLElement | undefined): void {
  el?.addEventListener('keydown', (event: KeyboardEvent) =>
    focustrapEvent(event, el),
  );
}

/**
 *
 * @param el
 */
export function removeTrapFocusToElement(el: HTMLElement | undefined): void {
  el?.removeEventListener('keydown', (event: KeyboardEvent) =>
    focustrapEvent(event, el),
  );
}
